<template>
  <el-container
    class="pagoda-layout"
    :class="{'pagoda-layout--fullscreen': isFullscreen}"
  >
    <el-header
      class="pagoda-layout__el-header"
      v-show="!isFullscreen"
      v-bind="headerProps"
    >
      <div
        class="header-slot header-slot--left"
        ref="headerSlotLeft"
      >
        <slot name="header-left"></slot>
      </div>
      <div
        class="iconfontbox"
        @click="isCollapse = !isCollapse"
      >
        <i
          :class="[
            'iconfont',
            'menu-collapse',
            isCollapse ? 'icon-caidan-zhankai' : 'icon-caidan-shouqi'
          ]"
        ></i>
      </div>
      <div
        class="header-slot"
        v-if="$slots['header-slot']"
      >
        <slot name="header-slot"></slot>
      </div>
      <div class="header-slot header-slot--right">
        <slot
          name="header-right"
          v-if="$slots['header-right']"
        ></slot>
        <pagoda-user-info
          v-if="userInfo"
          v-bind="userInfo"
          :on-logout="onLogout"
          :on-operate-item-click="onOperateItemClick"
        ></pagoda-user-info>
      </div>
      <el-menu
        mode="horizontal"
        :default-active="topMenuDefaultActive"
        v-bind="topMenuProps"
        pagoda-layout-menu
        ref="topMenu"
      >
        <el-menu-item
          v-if="topMenu && topMenu.length"
          v-for="item in topMenu"
          :index="item[urlKey]"
          :key="item[labelKey]"
          :disabled="item.disabled"
          @click="$emit('select-top-menu', item)"
        >{{item[labelKey]}}</el-menu-item>
      </el-menu>
    </el-header>
    <el-container style="min-height: 0">
      <el-aside
        class="pagoda-layout__el-aside"
        width="auto"
        v-show="!isFullscreen"
        v-bind="asideProps"
        ref="elAside"
      >
        <slot name="before-left-menu" />
        <side-menu
          style="height: 100%"
          v-if="sideMenu && sideMenu.length"
          :data="sideMenu"
          :labelKey="labelKey"
          :subMenuKey="subMenuKey"
          :urlKey="urlKey"
          :iconKey="iconKey"
          :config="sideMenuConfig"
          :collapse="isCollapse"
          :open-tab="openTab"
          :default-active="$route.fullPath"
          @hook:mounted="handleSideMenuReady"
          @item-click="handleSideMenuSelect"
          ref="sideMenu"
        ></side-menu>
      </el-aside>
      <el-container>
        <el-main class="pagoda-layout__el-main">
          <div class="pagoda-layout__tabs-wrapper">
            <el-tabs
              v-if="tabs && tabs.length"
              v-show="!isFullscreen"
              class="pagoda-layout__el-tabs"
              v-model="currentTab"
              type="card"
              @tab-remove="removeTab"
              @click.right.native.stop.prevent="handleTabMounseRightDown"
              ref="tabs"
            >
              <el-tab-pane
                v-for="(item, index) in tabs"
                :key="item.name"
                :label="item.title"
                :name="item.name"
                :closable="item.name !== indexTabLabel"
              ></el-tab-pane>
            </el-tabs>
            <span
              class="pagoda-layout__fullscreen-control"
              v-show="fullscreen"
              @click="isFullscreen = !isFullscreen"
            >
              <i
                class="fullscreen-icon iconfont"
                :class="[isFullscreen ? 'icon-huanyuanx' : 'icon-quanpingx']"
              ></i>
              {{isFullscreen ? '还原' : '全屏'}}
            </span>
          </div>
          <div class="pagoda-layout__main">
            <slot></slot>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <pagoda-drop-down ref="dropDown">
      <pagoda-drop-down-item
        :class="{'bb-1': i === tabCustomBtns.length - 1}"
        @click.native="btn.onClick && btn.onClick(tabData[currentOperateTab])"
        v-for="(btn, i) in tabCustomBtns"
        :key="i"
      >
        <i
          class="mr-10"
          :class="btn.iconClass"
        ></i>
        {{btn.text}}
      </pagoda-drop-down-item>
      <pagoda-drop-down-item @click.native="handleCloseCurrentTabs">关闭</pagoda-drop-down-item>
      <pagoda-drop-down-item @click.native="handleCloseOthersTabs">关闭其他</pagoda-drop-down-item>
      <pagoda-drop-down-item @click.native="handleCloseAllTabs">关闭所有</pagoda-drop-down-item>
    </pagoda-drop-down>
  </el-container>
</template>

<script>
import { Submenu, Menu, MenuItemGroup } from 'element-ui'

import { getEmptyArray, getEmptyObject, deepCopy, isFunction, noop } from '../../../utils'

import { addClass, removeClass } from '../../../utils/dom'

import Vue from 'vue'

import SideMenu from './side-menu'
import PagodaDropDown from '../../others/drop-down/drop-down'
import PagodaDropDownItem from '../../others/drop-down/drop-down-item'
import PagodaUserInfo from './user-info'

let tabKeySeed = 1

// 取消layout菜单中点击menu-item默认激活的行为
const oldMenuItemClickHanlder = Menu.methods.handleItemClick
Menu.methods.handleItemClick = function(...arg) {
  const oldActiveIndex = this.activeIndex

  oldMenuItemClickHanlder.call(this, ...arg)

  if ('pagoda-layout-menu' in this.$attrs) this.activeIndex = oldActiveIndex
}

export default {
  name: 'Layout',
  props: {
    labelKey: {
      type: String,
      default: 'label'
    },
    subMenuKey: {
      type: String,
      default: 'subMenu'
    },
    urlKey: {
      type: String,
      default: 'url'
    },
    iconKey: {
      type: String,
      default: 'icon'
    },
    sideMenu: {
      type: Array,
      default: getEmptyArray
    },
    headerProps: {
      type: Object,
      default: getEmptyObject
    },
    asideProps: {
      type: Object,
      default: getEmptyObject
    },
    sideMenuProps: {
      type: Object,
      default: getEmptyObject
    },
    topMenuProps: {
      type: Object,
      default: getEmptyObject
    },
    topMenu: {
      type: Array,
      default: getEmptyArray
    },
    tabsMax: {
      type: Number,
      default: 10
    },
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    topMenuDefaultActive: {
      type: String,
      default: window.location.href
    },
    collapseIcon: [String, Array],
    collapse: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    tabCustomBtns: {
      type: Array,
      default: getEmptyArray
    },
    userInfo: Object,
    indexTab: Object,
    beforeTabsChange: {
      type: Function,
      default(next) {
        next()
      }
    },
    beforeTabRemove: {
      type: Function,
      default(next) {
        next()
      }
    },
    onLogout: {
      type: Function,
      default: noop
    },
    onOperateItemClick: {
      type: Function,
      default: noop
    }
  },
  provide() {
    return {
      layoutInstance: this
    }
  },
  data() {
    this.init = true

    const indexTab = this.indexTab || { [this.labelKey]: '首页', [this.urlKey]: '/' }

    this.indexTabLabel = indexTab[this.labelKey]
    this.indexTabUrl = indexTab[this.urlKey]

    this.tabData = {
      [this.indexTabLabel]: {
        [this.labelKey]: this.indexTabLabel,
        [this.urlKey]: this.indexTabUrl
      }
    }

    return {
      currentTab: this.indexTabLabel,
      isCollapse: false,
      isFullscreen: false,
      tabs: [
        {
          title: this.indexTabLabel,
          name: this.indexTabLabel
        }
      ]
    }
  },
  mounted() {
    const { tabs } = this.$refs

    const oldTabClickHandle = tabs.handleTabClick
    tabs.handleTabClick = tab => {
      if (this.currentTab !== tab.name) {
        this.beforeTabsChange(
          () => {
            oldTabClickHandle.call(tabs, tab)
            this.$emit('tabs-change', this.tabData[tab.name])
          },
          {
            action: 'change'
          }
        )
      }
    }

    this.$pagoda.$on('layout:remove-current-tab', this.safeRemoveCurrentTab)
    this.$pagoda.$on('layout:remove-all-tab', this.safeRemoveAllTab)
    // 向下兼容
    this.$pagoda.$on('layout-remove-current-tab', this.safeRemoveCurrentTab)
  },
  beforeDestroy() {
    this.$pagoda.$off('layout:remove-current-tab', this.safeRemoveCurrentTab)
    this.$pagoda.$off('layout:remove-all-tab', this.safeRemoveAllTab)
    // 向下兼容
    this.$pagoda.$off('layout-remove-current-tab', this.safeRemoveCurrentTab)
  },
  methods: {
    handleSideMenuReady() {
      const { sideMenu, headerSlotLeft } = this.$refs

      if (sideMenu) {
        sideMenu.$refs.elMenu.pagodaMenu = true
      }

      this.$pagoda.$emit('form-table-layout:dolayout')
    },
    initCollapseController() {
      if (this.collapse && this.sideMenu.length && !this.collapseController) {
        this.collapseController = new collapseController({
          data: {
            isCollapse: this.isCollapse,
            collapseIcon: this.collapseIcon
          },
          watch: {
            isCollapse: val => {
              this.isCollapse = val
            }
          }
        })

        this.collapseController.$mount()

        this.$el.querySelector('.el-container').appendChild(this.collapseController.$el)
      }
    },
    safeRemoveOthersTabs(curTab) {
      this.tabs = this.tabs.filter(tab => {
        if (tab.name === curTab || tab.name === this.indexTabLabel) {
          return true
        } else {
          this.tabData[tab.name] = null
          return false
        }
      })
    },
    safeRemoveAllTab() {
      this.tabs = this.tabs.filter(tab => tab.name === this.indexTabLabel)
      this.tabData = {
        [this.indexTabLabel]: {
          [this.labelKey]: this.indexTabLabel,
          [this.urlKey]: this.indexTabUrl
        }
      }
    },
    handleCloseAllTabs() {
      this.beforeTabRemove(
        () => {
          if (this.currentTab !== this.indexTabLabel) {
            this.beforeTabsChange(
              () => {
                this.safeRemoveAllTab()
                this.currentTab = this.indexTabLabel
                this.$emit('tabs-change', this.tabData[this.currentTab])
              },
              {
                action: 'remove'
              }
            )
          } else {
            this.safeRemoveAllTab()
          }
        },
        {
          removeTabs: this.tabs
            .filter(({ name }) => name !== this.indexTabLabel)
            .map(({ name }) => this.tabData[name])
        }
      )
    },
    handleCloseCurrentTabs() {
      this.currentOperateTab &&
        this.currentOperateTab !== this.indexTabLabel &&
        this.removeTab(this.currentOperateTab)
    },
    handleCloseOthersTabs() {
      this.beforeTabRemove(
        () => {
          if (this.currentOperateTab) {
            if (this.currentTab !== this.currentOperateTab) {
              this.beforeTabsChange(
                () => {
                  this.safeRemoveOthersTabs(this.currentOperateTab)
                  this.currentTab = this.currentOperateTab
                  this.$emit('tabs-change', this.tabData[this.currentTab])
                },
                {
                  action: 'remove'
                }
              )
            } else {
              this.safeRemoveOthersTabs(this.currentOperateTab)
            }
          }
        },
        {
          removeTabs: this.tabs
            .filter(({ name }) => name !== this.currentOperateTab && name !== this.indexTabLabel)
            .map(({ name }) => this.tabData[name])
        }
      )
    },
    handleTabMounseRightDown(e) {
      const target = e.target

      if (target.className.split(' ').includes('el-tabs__item')) {
        const documentEl = document.documentElement
        const body = document.body
        const scrollLeft = Math.max(documentEl.scrollLeft, body.scrollLeft)
        const scrollTop = Math.max(documentEl.scrollTop, body.scrollTop)

        this.$refs.dropDown.show({
          left: e.clientX + scrollLeft,
          top: e.clientY + scrollTop
        })

        const operateTabIdx = Array.from(
          this.$refs.tabs.$el.querySelectorAll('.el-tabs__item')
        ).findIndex(tabs => tabs === target)
        this.currentOperateTab = this.tabs[operateTabIdx].name
      }
    },
    handleSideMenuSelect(selectItem) {
      const key = selectItem.key || selectItem.tabName || selectItem[this.labelKey]

      this.$emit('select-side-menu', selectItem)

      if (key !== this.currentTab) {
        this.beforeTabsChange(
          () => {
            this.$emit('tabs-change', this.tabData[key] || selectItem)
          },
          {
            action: 'change'
          }
        )
      }
    },
    openTab(selectItem) {
      const key = selectItem.key || selectItem.tabName || selectItem[this.labelKey]
      const title = selectItem.tabName || selectItem[this.labelKey]

      if (!this.tabData[key]) {
        this.tabs.push({
          title,
          name: key
        })
      }

      this.tabData[key] = selectItem
      this.currentTab = key

      if (this.tabs.length > this.tabsMax) {
        const firstTabKey = this.tabs[1].name

        this.removeTab(firstTabKey)
      }
    },
    safeRemoveCurrentTab() {
      this.safeRemoveTab(this.currentTab)
    },
    safeRemoveTab(targetName) {
      let tabs = this.tabs
      let activeName = this.currentTab
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1] || tabs[0]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }

      this.tabs = tabs.filter(tab => tab.name !== targetName)
      this.tabData[targetName] = null
      return activeName
    },
    removeTab(targetName) {
      this.beforeTabRemove(
        () => {
          if (this.currentTab === targetName) {
            this.beforeTabsChange(
              () => {
                this.currentTab = this.safeRemoveTab(targetName)
                this.$emit('tabs-change', this.tabData[this.currentTab])
              },
              {
                action: 'remove'
              }
            )
          } else {
            this.safeRemoveTab(targetName)
          }
        },
        {
          removeTabs: [this.tabData[targetName]]
        }
      )
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        const tabConfig = to.meta.tabConfig

        if (tabConfig) {
          const tabName = isFunction(tabConfig.tabName)
            ? tabConfig.tabName(to, from)
            : tabConfig.tabName

          let config = {
            ...to,
            tabName,
            [this.urlKey]: to.fullPath,
            pathMathFull: true
          }

          if (tabConfig.alwaysNewTab) {
            config.key = to.fullPath
          }

          this.openTab(config)
        } else if (to.fullPath === this.indexTabUrl) {
          this.openTab({
            [this.labelKey]: this.indexTabLabel,
            [this.urlKey]: this.indexTabUrl
          })
        }
      }
    },
    isFullscreen() {
      this.$pagoda.$emit('form-table-layout:dolayout')
    },
    tabs() {
      this.$emit(
        'tabs-data-change',
        this.tabs.map(tab => this.tabData[tab.name]).filter(tab => !!tab)
      )
    },
    isCollapse(val) {
      setTimeout(() => {
        this.$pagoda.$emit('form-table-layout:dolayout')
      }, 200)

      this.$emit('collapse-change', val)
    }
  },
  computed: {
    sideMenuConfig() {
      return {
        ...this.sideMenuProps,
        collapse: this.isCollapse
      }
    }
  },
  components: {
    SideMenu,
    PagodaDropDown,
    PagodaDropDownItem,
    PagodaUserInfo
  }
}
</script>
